import { Pipe, PipeTransform } from '@angular/core';
import {Bonus} from "../../models";

@Pipe({
  name: 'contractAmountSum'
})
export class ContractAmountSumPipe implements PipeTransform {

  transform(value: Bonus[] = [], ...args: unknown[]): unknown {
    if (value.length>0){
      return value.reduce((n, {total}) => n + total, 0).toFixed(2);
    }else {
      return 0;
    }
  }

}
